import m from "../../geodata/es2015/fijiEastLow";
window.am4geodata_fijiEastLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/fijiEastLow.js
// module id = null
// module chunks = 